export default "__VITE_ASSET__DSZqHagf__"